// Public changelog entries. Append new entries at the TOP with the next number.
// number: running update number (increment by 1)
// date: ISO string or readable date
// title: short headline
// changes: array of bullet points describing changes

export const CHANGELOG = [
  // Update #4 – Visual Builder Optimierungen
  {
    number: 4,
    date: "2025-11-22",
    title: "Update #4 – Visual Builder Optimierungen & UX-Verbesserungen",
    description:
      "Dieses Update bringt zahlreiche Verbesserungen am Visual Builder: kompakteres Layout, verschiebbare Panels und optimierte Bedienung.",
    changes: [
      "Vollbild-Modus für den Visual Builder – per Knopf aktivierbar, mit ESC schließbar.",
      "Verschiebbare Panel-Breiten: Blockpalette und Einstellungen-Panel können individuell angepasst werden.",
      "Config/Navigator-Tabs: Navigator wurde in die Einstellungen integriert – zwischen Config-Ansicht und Navigator-Ansicht umschaltbar.",
      "Auto-Öffnen: Block-Einstellungen öffnen sich automatisch beim Klicken auf ein Modul.",
      "Einklappbare Blockpalette: kann bei Bedarf minimiert werden für mehr Arbeitsbereich.",
      "Versionen-Modal: Versionsverlauf jetzt als Popup abrufbar mit Rollback-Funktion.",
      "Kompakte Toolbar: Vorlagen, Speichern, Preview und Publish-Buttons als Icon-Leiste im Header.",
      "Visual Editor/JSON-Dropdown: Zwischen Visual Builder und JSON Editor per Dropdown wechselbar.",
    ],
  },
  // Update #3 – Datenschutz & Consent (heutige Änderungen)
  {
    number: 3,
    date: "2025-11-11",
    title: "Update #3 – Datenschutz, Cookie Consent & präzisere Events",
    description:
      "Dieses Update stärkt Datenschutz & Transparenz: eigene Datenschutzerklärung, granularer Cookie-Consent und Einwilligungs-gesteuerte Event-Messung.",
    changes: [
      "Neue öffentliche Seite: /datenschutz – Inhalt im System-Dashboard bearbeitbar.",
      "Footer erweitert: Link zu Datenschutz und erneutem Öffnen der Cookie-Einstellungen.",
      "Cookie-Banner unten rechts (Desktop & Mobil) mit Kategorien: Notwendig, Analyse, Marketing.",
      "Persistente Einwilligung (localStorage + Consent-Cookie) – Fenster kann jederzeit über Footer erneut geöffnet werden.",
      "Marketing-Events (Lead, CompleteRegistration, Purchase) werden nur noch bei Marketing-Einwilligung gesendet.",
      "ViewContent-Event (Code-Anzeige) wird nur noch bei Analyse-Einwilligung gesendet.",
      "Saubere Trennung interner KPIs (vollständig) vs. Meta CAPI KPIs (consent-gefiltert).",
      "Technik: Consent-Cookie cm_consent=a=1.m=1 und serverseitiges Gating in Meta CAPI Pipeline.",
    ],
  },
  // Update #2 – Meta Conversions & Messbarkeit (heutige Änderungen)
  {
    number: 2,
    date: "2025-10-16",
    title: "Update #2 – Meta Conversion Integration & Messbarkeit",
    description:
      "Fokus dieses Updates: einfache Einrichtung der Meta Conversions API und eine klarere Messung der Ergebnisse.",
    changes: [
      "Neue Meta-Einstellungen in der Organisation: Pixel-ID, Access Token, Testcode und Währung – plus Standard-Eventname und Standard-Conversion-Wert.",
      "EU-Datenverarbeitung (LDU) kann optional aktiviert werden.",
      "Pro Aktion: Meta kann separat aktiviert werden; eigener Eventname und eigener Conversion-Wert möglich; Pixel/Testcode optional übersteuerbar.",
      "Messung verbessert: Lead (Scan-Start), Bestätigung, Code-Anzeige und Einlösung werden automatisch als Events gezählt – inklusive Wert & Währung (falls hinterlegt).",
      "Sicherheit: Alle Meta-Zugangsdaten werden verschlüsselt gespeichert.",
      "Kleine UX-Verbesserung: Hinweise stehen jetzt oberhalb der Speichern-Buttons.",
    ],
  },
  // Endnutzer-freundlich: ein zusammengefasstes Update (#1)
  {
    number: 1,
    date: "2024-10-15",
    title: "Update #1 – Bug-Fixes & Verbesserungen",
    description:
      "Dieses Update bündelt alle von dir genannten Punkte – verständlich und auf den Punkt.",
    changes: [
      "Bild/Video-Modul: Videos können per Klick pausiert/fortgesetzt werden; Steuerelemente sind sichtbar (wenn gewünscht).",
      "Kampagnen können wieder gelöscht werden – verknüpfte Daten werden dabei automatisch aufgeräumt.",
      "Merchant-Dashboard: Aktionen direkt neben den Kampagnen – schneller Zugriff ohne Umwege.",
      "Pflichtfelder sind klar gekennzeichnet (Stern) und werden beim Absenden/Veröffentlichen geprüft.",
      "Kampagnen-Auswahl: Beim Anlegen von Aktionen werden nur aktive Kampagnen angeboten; inaktive sind klar als \"(inaktiv)\" markiert.",
      "Texteditor: Ausrichtung links, zentriert, rechts und Blocksatz bequem auswählbar.",
      "Code-Ausgabe nur mit Newsletter-Einwilligung – ohne Häkchen gibt es keinen Code.",
      "Mitarbeiter-Dashboard: QR-Code-Scanner im Vollbild mit Taschenlampen-Schalter und automatischer Code-Übernahme.",
    ],
  },
];
